import apiFetch from '../apiFetch'

export default function (token, templateId, body) {
  return apiFetch({ endPoint: `template/${templateId}/field/${body.templateFieldId}`, method: 'PUT', body: body, token: token })
}
